function renderCartTemplate() {
	fetch(`${routes.cart_url}?section_id=main-cart-items`)
		.then((response) => response.text())
		.then((responseText) => {
			const html = new DOMParser().parseFromString(responseText, 'text/html');
			const cartItemsNew = $(html).find('cart-items');
			const cartItems = $('[js-cart-template] cart-items');
			cartItems.empty().append(cartItemsNew.html());
		})
		.catch(e => {
			console.error(e);
		});
}

function renderSections(data) {
	if (data.item_count === 0 ) {
		$('[js-cart-template]').addClass('is-empty');
		$('[data-cart-count-bubble]').addClass('d-none');
	}else if (data.item_count > 0) {
		$('[data-cart-count]').text(data.item_count);
		$('[data-cart-count-bubble]').removeClass('d-none');
	}
	
	getSectionsToRender().forEach((section => {
	  	const html = new DOMParser().parseFromString(data.sections[section.section], 'text/html');
	  	const elementToReplaceNew = $(html).find(section.selector);
	  	const elementToReplace = $(section.id).find(section.selector) || $(section.id);
		elementToReplace.empty().append(elementToReplaceNew.html());
	}));
}

function enableLoading(line) {
    const cartItemElements = $('#CartItem-' + line +' .loading__spinner');
    const cartItemElementsPrice = $('#CartItem-' + line +' [js-loading-price]');
    cartItemElements.removeClass('d-none');
    cartItemElementsPrice.addClass('d-none');
}

function disableLoading(line) {
    const cartItemElements = $('#CartItem-' + line +' .loading__spinner');
    const cartItemElementsPrice = $('#CartItem-' + line +' [js-loading-price]');
    cartItemElements.addClass('d-none');
    cartItemElementsPrice.removeClass('d-none');
}

function updateLiveRegions(line_item, response) {
	var lineItemError = '#Line-item-error-' + line_item;
	$(lineItemError).removeClass('d-none');
	$(lineItemError).find('[data-cart-item__error-text]').empty().append(response.responseJSON.message);
}

function getSectionsToRender() {
    return [
      {
        id: '#main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '[js-contents-items]'
      },
      {
        id: '#main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '[js-contents-summary]'
      },
      {
        id: '#main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '[js-contents-method-delivery]'
      },
      {
        id: '#main-cart-payments',
        section: document.getElementById('main-cart-payments').dataset.id,
        selector: '[js-contents-ctas]'
      }
    ];
}
/* Update Minicart */
/* -------------------------------------------------------------------------------------- */
function updateCartTemplate(iQuantity, line_item) {
	enableLoading(line_item);

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
		data: {
			quantity: iQuantity,
			line: line_item,
			sections: getSectionsToRender().map((section) => section.section),
      		sections_url: window.location.pathname
		},
		dataType: 'json',           
		success: function(data) {
			renderSections(data);
		},
		complete: function() {
			disableLoading(line_item);
		},
		error: function(response) {
			updateLiveRegions(line_item, response);
		}
	});
}
/* Update cart with note */
/* -------------------------------------------------------------------------------------- */
function updateNoteCart(iNote) {
	$.ajax({
		type: 'POST',
		url: '/cart/update.js',
		data: {
			note: iNote
		},
		dataType: 'json',           
		success: function() {
		},
		error: function() {
		}
	});
}

document.addEventListener('DOMContentLoaded', () => {
	/* Add note to cart */
	/* -------------------------------------------------------------------------------------- */
	$('.carts-footer').on('keydown', '[js-cart-add-note]', debounce(function(){
		var el = $(this);
		var note = el.val();
		updateNoteCart(note);
    },500));
	/* Quantity Product */
	/* -------------------------------------------------------------------------------------- */
	$('.carts-items').on('click', '[name=minus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			input = spinner.closest('.js-quantity-cart-template').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(input.attr("data-index"));
		if (oldValue <= min) {
			var newVal = oldValue;
			spinner.attr('disabled', '');
		} else {
			var newVal = oldValue - 1;
			spinner.removeAttr('disabled');
		}
		input.val(newVal);
		input.trigger("change");
		updateCartTemplate(newVal,line_item);
	});

	$('.carts-items').on('click', '[name=plus]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var spinner = $(this),
			spinnerSibling = $(this).siblings('[name=minus]'),
			input = spinner.closest('.js-quantity-cart-template').find('input[type="number"]'),
			min = input.attr('min'),
			max = input.attr('max'),
			oldValue = parseFloat(input.val()),
			line_item = parseFloat(input.attr("data-index"));
		if (oldValue >= max) {
			var newVal = oldValue;
			spinnerSibling.attr('disabled', '');
		} else {
			var newVal = oldValue + 1;
			spinnerSibling.attr('disabled', '');
		}
		input.val(newVal);
		input.trigger("change");
		updateCartTemplate(newVal,line_item);
	});

	$('.carts-items').on('keyup', '.js-quantity-cart-template .quantity__input', debounce(function(){
		var input = $(this),
			inputValue = parseFloat(input.val()),
			line_item = input.attr("data-index");
		updateCartTemplate(inputValue,line_item);
	},500));
	/* Remove Product */
	/* -------------------------------------------------------------------------------------- */
	$('[js-cart-template]').on('click', 'cart-remove-button', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		var line_item = el.attr('data-index');
		updateCartTemplate(0,line_item);
	});
});